module.exports = __webpack_public_path__ + "static/media/1POLICY23.9b824912.jpg";